import React from "react";
import OrCineWidget from "../../../components/OrCineWidget";

export default function Cinema(props) {
  return <OrCineWidget {...props} />;
}
